import React, { useState } from 'react';
import { 
  Container, 
  Grid, 
  Card, 
  CardMedia, 
  Typography, 
  Modal, 
  Box, 
  IconButton, 
  Fade,
  Backdrop
} from '@mui/material';
import PlayCircleFilledWhiteIcon from '@mui/icons-material/PlayCircleFilledWhite';
import CloseIcon from '@mui/icons-material/Close';
import { motion } from 'framer-motion';

// १३ व्हिडिओंची लिस्ट (फक्त length बदलून १३ केली आहे)
const videoData = Array.from({ length: 13 }, (_, index) => ({
  id: index + 1,
  path: `/videos/video${index + 1}.mp4`,
}));

// Popup (Modal) ची स्टाईल
const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: { xs: '95%', sm: '85%', md: '70%', lg: '60%' },
  bgcolor: '#000',
  boxShadow: 24,
  outline: 'none',
  borderRadius: '10px', 
  overflow: 'hidden',
  position: 'relative'
};

export default function VideoGallery() {
  const [open, setOpen] = useState(false);
  const [currentVideo, setCurrentVideo] = useState('');

  // व्हिडिओ ओपन करण्यासाठी
  const handleOpen = (videoPath) => {
    setCurrentVideo(videoPath);
    setOpen(true);
  };

  // व्हिडिओ बंद करण्यासाठी
  const handleClose = () => {
    setOpen(false);
    setCurrentVideo('');
  };

  return (
    <Container maxWidth="lg" sx={{ py: 6 }}>
      
      {/* मुख्य हेडिंग */}
      <Typography 
        variant="h3" 
        component="h1" 
        align="center" 
        gutterBottom 
        sx={{ 
          fontWeight: 'bold', 
          fontFamily: '"Noto Serif Devanagari", serif', 
          color: '#5a1e1e', 
          mb: 5,
          fontSize: { xs: '2rem', sm: '2.5rem', md: '3rem' } 
        }}
      >
        “ग्रंथालय उद्घाटन व्हिडिओ” 
      </Typography>

      {/* व्हिडिओ ग्रिड */}
      <Grid container spacing={3}>
        {videoData.map((video) => (
          <Grid item key={video.id} xs={12} sm={6} md={3}>
            
            {/* सुंदर कार्ड ॲनिमेशन */}
            <motion.div
              whileHover={{ scale: 1.05, y: -5 }}
              whileTap={{ scale: 0.95 }}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3, delay: video.id * 0.05 }}
            >
              <Card 
                sx={{ 
                  cursor: 'pointer', 
                  position: 'relative',
                  borderRadius: '10px', 
                  boxShadow: '0 6px 20px rgba(90,30,30,0.15)', 
                  overflow: 'hidden',
                  display: 'flex',
                  '&:hover .play-overlay': { opacity: 1 }
                }}
                onClick={() => handleOpen(video.path)}
              >
                {/* व्हिडिओ थंबनेल */}
                <CardMedia
                  component="video"
                  src={video.path}
                  sx={{ height: 200, width: '100%', objectFit: 'cover' }}
                  preload="metadata"
                />

                {/* प्ले बटन ओव्हरले */}
                <Box
                  className="play-overlay"
                  sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    bgcolor: 'rgba(243, 156, 18, 0.25)', 
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    opacity: 0,
                    transition: 'opacity 0.3s ease',
                  }}
                >
                  <PlayCircleFilledWhiteIcon sx={{ fontSize: 65, color: '#f39c12' }} /> 
                </Box>
              </Card>
            </motion.div>

          </Grid>
        ))}
      </Grid>

      {/* व्हिडिओ प्ले करण्यासाठी Popup Modal */}
      <Modal
        open={open}
        onClose={handleClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
            sx: { backgroundColor: 'rgba(26, 8, 8, 0.88)' } 
          },
        }}
      >
        <Fade in={open}>
          <Box sx={modalStyle}>
            
            {/* व्हिडिओ बंद करण्यासाठी क्लोज बटन */}
            <IconButton
              onClick={handleClose}
              sx={{
                position: 'absolute',
                top: 10,
                right: 10,
                color: '#fff',
                bgcolor: '#5a1e1e', 
                '&:hover': { bgcolor: '#f39c12', color: '#000' }, 
                zIndex: 10,
                boxShadow: '0 2px 10px rgba(0,0,0,0.3)'
              }}
            >
              <CloseIcon />
            </IconButton>

            {/* मुख्य व्हिडिओ प्लेअर */}
            {currentVideo && (
              <video 
                key={currentVideo}
                width="100%" 
                controls 
                autoPlay // पॉपअप ओपन झाल्यावर व्हिडिओ लगेच प्ले व्हावा म्हणून (पर्यायी)
                style={{ display: 'block', maxHeight: '80vh', backgroundColor: '#000' }}
              >
                <source src={currentVideo} type="video/mp4" />
                तुमचा ब्राउझर व्हिडिओ सपोर्ट करत नाही.
              </video>
            )}

          </Box>
        </Fade>
      </Modal>

    </Container>
  );
}